import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { invalidateBookingInflight } from "./getBooking";

export async function deleteBookedOffer(bookingId: string, offerId: string): Promise<IApiResponse<any>> {
    const endpoints = await getEndpoints();
    const endpoint = endpoints.deleteBookOfferToBookingAPI(bookingId, offerId);
    // `return await` + finally — see addOfferToBooking. The shuttle EDIT path is
    // add-then-delete, so a read joining a pre-delete GET puts the replaced
    // offer back on the receipt and bills two shuttles for one journey.
    try {
        return await apiRequest<any>(endpoint, "DELETE");
    } finally {
        invalidateBookingInflight(bookingId);
    }
}
